import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'https://um-dragoneye.andrian-nazriel04.workers.dev';

const apiClient = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

apiClient.interceptors.response.use(
  (res) => res,
  async (error) => {
    if (error.response && error.response.status === 401 && window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const AUTH_BASE = API_BASE;

export { apiClient, AUTH_BASE };
